var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ch-filter-in-detail"},[_c('bookings-filter',{staticClass:"ma-0 mb-3",attrs:{"doorlockBookingId":_vm.id}}),_vm._v(" "),_c('bookings-list',{attrs:{"doorlockBookingId":_vm.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f6a1b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/doorlocks/DoorlockBookings.vue
// module id = null
// module chunks = 